<template>
  <footer class="footer-legal" :style="estilo">
    Desarrollado por <a href="https://megapos.co" target="_blank">megapos.co</a>
  </footer>
</template>

<script>
import HttpService from '../Servicios/HttpService'
import { ColorContrasteMixin } from './mixins/ColorContrasteMixin'

export default {
  name: 'FooterLegal',
  mixins: [ColorContrasteMixin],
  data() {
    return {
      color: '#1e293b'
    }
  },
  computed: {
    estilo() {
      return {
        background: `linear-gradient(90deg, ${this.color} 0%, ${this.color}CC 100%)`,
        color: this.colorContraste(this.color)
      }
    }
  },
  mounted() {
    this.obtenerColor()
  },
  methods: {
    async obtenerColor() {
      try {
        const res = await HttpService.registrar('eventos.php', { accion: 'obtener' })
        if (Array.isArray(res) && res.length) {
          this.color = res[0].color_principal
        }
      } catch (e) {
        // mantenemos el color por defecto
      }
    }
  }
}
</script>

<style scoped>
.footer-legal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
  font-family: 'Segoe UI', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  box-shadow: 0 -2px 6px rgba(119, 111, 230, 0.3);
  z-index: 1000;
}

.footer-legal a {
  color: inherit;
  text-decoration: underline;
  margin-left: 4px;
}

.footer-legal a:hover {
  text-decoration: none;
}
</style>
